<template>
    <div :id="blog.slug" class="blog-card-grid" ref="RecentBlogCard">
      <a :href="blog.store_front_link" target="_blank" class="image">
        <img
          @error="handleImageError"
          :src="blog.base_image"
          :class="{ 'image-placeholder': !blog.base_image }"
          alt="blog image"
        />
      </a>
      <div class="description mt-auto">
        <h4>
          <a :href="blog.store_front_link" target="_blank" class="blog-name">{{ blog.name }}</a>
        </h4>
        <div>
            <span class="text-muted">Posted on {{ blog.created_at }}</span>
            <span></span>
        </div>
      </div>
    </div>
</template>

<script>
    import DefaultImageMixin from "@core/mixin/DefaultImageMixin"

    export default {

        mixins: [DefaultImageMixin],
        props: ["blog"]
    }
</script>
<style lang="scss">
.blog-card-grid {
    display: flex !important;
    height: 100%;
    width: 100%;
    flex-direction: column;
    padding: 16px;
    border: 1.5px solid #cfcfcf;
    border-radius: 8px;
    position: relative;

    .image {
        height: 250px;
        cursor: pointer;

        img {
        height: 100%;
        width: 100%;
        object-fit: contain;
        }
    }

    .description {
        padding-top: 8px;

        > h4 {
            .blog-name {
                font-size: 16px;
                font-weight: 500;
                display: -webkit-box;
                -webkit-line-clamp: 3; /* Limit the content to 3 lines */
                -webkit-box-orient: vertical;
                overflow: hidden;
                max-width: 100%;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>
